/**
 * 状态类：status { success、error、warn }
 * 弹窗类：dialog { toast、alert、confirm }
 * 表单类：from { placeholder、label }
 * 表格类：table { }
 *
 * 接口请求类：request
 * 接口响应类：responce
 *
 * 页面模块类：
 *
 */

// 使用 {{$t("purchase.periods")}}  //第*期

// 状态
const state = {
  preheatIng: "준비중",
  purchaseIng: "판매중",
  process: "참여중",
  over: "종료",
  finish: "완성",
  noData: "데이터 없음",
};

const common = {
  wan: "만",
  qian: "천",
  yi: "억",
};

//抢购区和个人抢购记录页上方的subheader
const subheader = {
  pricePromise: "확실한 가격보장",
  vipPrice: "VIP 혜택",
  protection: "피아트를 표준으로 가격 보호 기능 제공",
  pricePromiseVal: "[*]-일 가격 보장",
  rewards: "[*]% 보상, 가격 보호",
  vipDis: "VIP 할인혜택",
  zlz: "참여중",
};

// 抢购区
const purchase = {
  periods: "번째",
  timesSheaves: "제[*]차",
  supportPic: "[*]일 가격 보증",
  earnings: "[*]% 수익, 가격 보장",
  vipDiscount: "VIP 할인",
  limit: "이번 리스팅 한도",
  timeLimit: "한시 가격",
  schedule: "현재 상황",
  finishHalf: "[*]% 완성",
  subscriptionNum: "구입 수량",
  vipText: "(VIP[*])구입 시([**] [***] [****]%)할인",
  supportType:
    "가격 보장 방식: 가격 보장 시간내, BiKing는 제일 낮은 가격으로 매수 주문을 할 것이며, 회원님이 해당 시간 내에 매도를 선택할 수 있습니다. 가격 보장 시간이 끝난 후, 해당 최저 가격 주문이 취소됩니다.",
  beAbouttoAlipay: "출시 예정",
  atOnceAlipay: "즉시 구입",
  atOnceAlipayNew: "참여하기",
  atOnceAlipayed: "다음 라운드 지켜봐 주세요",
  atOnceAlipayedOver: "이미 참여했습니다.",
  atOnceAlipayedNew: "참여 완료, 다음 라운드 대기",
  atOnceAlipayedNewOver: "이미 참여하여, 참여할 수 없습니다.",
  website: "사이트",
  whitePaper: "백서",
  foreshow: "통지",
  startToUp: "판매 시작",
  startToUpNew: "참여하기",
  distanceStartToUp: "판매 카운트다운",
  num: "현재까지 ([*])명이 ([**]) BAT)를 구입",
  bannerText: "[*] [**] 구입 한도 획득",
  bannerTextNew: "[*] 모금[**]",
  nextProject: "구입이 완료되었으므로, 다음 프로젝트를 기다려주세요.",
  timesText:
    "이번 리스팅이 끝났으며 다음 [*]월 [**]일 [***]:[****]:[*****] 시작합니다.",
  times: "[*] 일 [**] 시 [***] 분 [****] 초",
  viewDetail: "자세히 보기",
  completePawd: "거래 비밀번호 설정 완료",
  sureCoins: "계정에 반드시 [*] [**] 이상인지 확인해주세요.",
  sureBalance: "[*] 잔액은 [**] 보다 많아야 합니다",
  set: "설정하기",
  available: "가능",
  holding: "홀딩",
  startSoon: "시작 예정",
  startSoonNew: "시작 예정",
  projectSupp: "프로젝트 금액",
  projectSuppNew: "한도",
  successBuy: "구입 성공",
  successBuyNew: "구입 성공",
  projectLimit: "프로젝트 시작",
  subscription: "모금 성공",
  subscriptionNew: "성공",
  projectGoal: "해당 프로젝트 자금 조달액",
  projectGoalNew: "해당 프로젝트 자금 조달액",
  goalFunds: "모금 자금이 목표에 도달하였습니다.",
  goalFundsNew: "모금 자금이 목표에 도달하였습니다.",
};

//抢购条件

const purchaseCondition = {
  q: " 및 ",
  h: " 또는 ",
  cztj: "입금액",
  wqyh: "관련 과거 이벤트에 참여하지 않은 사용자에 한함\n",
  vipdj: "VIP[*] 유저 혹은 VIP 유저 만 해당",
  condition: "구입 조건",
  conditionNew: "조건",
  nameverify1: "중국 대륙 회원 KYC 완성 ",
  nameverify2: "중국 대륙 이외 KYC 완성",
  nameverify3: "BiKing KYC인증 완성",
  login: "로그인",
  maxBuyin: "최대 매수",
  verify: "KYC 인증 하기",
  affirm: "위치가 다음보다 큰지 확인하십시오[*]",
  myPosition: "나의 홀드량",
  AmountOfAscension: "구입 수량",
  AmountOfAscensionNew: "구입 수량",
  AmountOfAscensionText:
    "첫차 시작 전 7일 동안 COINS 홀드량이 많으수록 구입한도가 많습니다.",
  AmountOfAscensionTime: "나의 이전7 일 [*] 일일  홀드량",
  discount: "구입 할인",
  vip_discount: "참여 할인",
  discountText: "VIP 레벨이 높으수록, 구입 가격이 저렴해집니다.",
  upgrade: "레벨 올리기",
  vipUpgrade: "나의 VIP",
  zled: "한도",
  wdzl: "나의 모금기록",
  zlxm: "프로젝트",
  mlzl: "매차 수량",
  zlmx: "모금 상세설명",
  ccff: "초방",
  qgmx: "구입 상세설명",

  fjtj: "추가 조건",
  guoji: "국적",
  noJoin: "지원하지않음",
  wancheng: "완료",
  pinggu: "<암호화폐 자산 투자 위험 평가 설문>",
  cyhd: "참가하기",
};

// 历史项目
const historyProject = {
  rushLimit: "구입 한도",
  averagePic: "평균 가격",
  averageNum: "구입 인원수",
};

// 支付
const alipay = {
  alipaynum: "구입 수량",
  alipaynumNew: "수량",
  ShouldPay: "지불 해야 함",
  VipDiscounts: "VIP 혜택",
  VipWin: "win회원공제",
  willOpen: "시작예정",
  actualPayment: "결제",
  actualPaymentNew: "이번 라운드",
  importPassword: "거래 비밀번호를 입력해 주세요.",
  forGetPassword: "거래 비밀번호 분실？",
  promptlyAlipay: "즉시 결제",
  purchaseSuccess: "축하합니다! 구입 성공!",
  purchaseSuccessNew: "축하합니다! 구입 성공!",
  purchaseError: "구입 실패, 죄송합니다. 새로고침 해서 다시 시도하십시오.",
};
// 项目详情
const projectDetails = {
  text: "홀드량이 1000 COINS이상 확인해주세요.",
  timelimitPic: "한시 가격",
  subscriptionLimit: "구입 한도",
  subscriptionLimitNew: "가격",
  preheat: "준비",
  supportAbort: "가격 보장 마감",
  unlockAbort: "발송 시간",
  projectIntroduction: "프로젝트 소개",
  projectRole: "프로모션 규칙",
  rule: "인수 규칙",
  ruleNew: "규칙",
};
// 抢购结束
const purchaseOver = {
  haveSubscribed: "이미 얻은 구입 한도",
  schedule: "현재 상황",
  Stime: "구입 시작 시간",
  StimeNew: "시작 시간",
  Etime: "구입 마감 시간",
  EtimeNew: "종료 시간",
  successText:
    "이 프로젝트 목표 한도 [*] BAT, 실제 조달 자산 목표 달성, 모금 성공!",
  success: "성공",
};

// 我的抢购
const myPurchase = {
  endUnlock: "최종 구입 끝난 후, 락 해제",
  endUnlock2: "최종  라운드 구입 종료",
  LText: "가격 보장 시간내, 매일 락 풀기",
  WText: "가격 보장 시간 외, 매일 락 풀기",
  unlockend: "락 해제됨",
  record: "자세한 사정",
  myPurchaseName: "참여한 프로젝트",
};

//mHeader
const mHeader = {
  sy: "목록",
  ksjy: "고속 거래",
  zyjy: "Pro",
  c2c: "C2C 거래",
  otc: "OTC 거래",
  zczx: "자산",
  xwgg: "뉴스",
  lc: "BiKing Earn",
  xwgg1: "뉴스",
  gxlc: "재테크",
  dxjh: "FansUp! ",
  fbjy: "코인구매",
  dl: "로그인",
  zc: "회원가입",
  jtzw: "简体中文",
  ftzw: "繁体中文",
  english: "English",
  kr: "한국어",
  qgms: "구입",
  xsjy: "제한 교역",

  zczgz: "추정 자산",
  yhzx: "계정",
  wdgl: "주문 관리",
  tc: "로그아웃",
  dltq: "저유통존",

  sdgm: "고속 교환",
  // app down
  appdown: "APP 다운로드",
  appdown1: "다운로드",
  biking: "BiKing APP",
  gfqb: "공식 지갑",
  xzbyapp: "BiKing 다운로드",
  xzbyapp2: "BiKing 다운로드",
  smewm: "QR 코드 스캔",
  xzhyqb: "HyperPay 지갑",
  xzhyqb2: "HyperPay 지갑",
  HyperPay: "HyperPay",
  byb: "금융",
  newPos: "HBT 마이닝",
  newlc: "금융",
  bbjy: "현물 거래",
  eftjy: "ETF 거래",
  hyjy: "선물 거래",
  hqlc: "PoS채굴",
  dd: "주문서",
  zichan: "자산",
  zhyaq: "계정 보안",
  xxzx: "消息中心",
  sfyz: "신원인증",
  wdvip: "나의 VIP",
  apigl: "API",
  hdzx: "활동중심",
  wdhb: "나의 레드포켓",
  flzx: "프로모션",
  bitloan: "비트론",
  ggjy: "레버리지 거래",
  hyxy: "아카데미",
  flhd: "증정 프로모션",
  bitWin: "BitWin",
};

//res
const res = {
  //抢购错误提示
  seckill_project_000: "시스템 오류",
  seckill_project_001: "프로젝트 사용 불가",
  seckill_project_002: "프로젝트 정보가 존재하지않습니다.",
  // 用户信息错误提示
  seckill_userInfo_001: "회원이 존재하지 않습니다.",
  //i18n错误提示
  i18n_no_table_001: "시스템 사용중",
  //抢购记录
  seckill_record_1: "결제 실패",
  //7日持仓规则
  seckill_7days_1: "해당 프로젝트의 규칙을 찾을 수 없습니다.",
  //钱包相关
  seckill_wallet_1: "시스템 사용중",
  seckill_wallet_2: "잔액 부족",
  seckill_wallet_3: "결제 실패",
  //项目统计
  seckill_record_count_1: "데이터 오류",
  seckill_record_count_2: "결제 실패",
  seckill_record_count_3: "결제 실패",
  //项目轮次
  seckill_rounds_1: "시스템 사용중",
  seckill_rounds_2: "해당 프로젝트중, 진행중인 세션이 없습니다.",
  seckill_rounds_3: "해당 프로젝트중, 진행중인 세션 정보가 없습니다.",
  seckill_rounds_4: "시스템 사용중",
  seckill_rounds_5: "해당 프로젝트 중, 지정된 세션을 찾지못하였습니다.",
  //项目信息
  seckill_pro_1: "프로젝트 정보를 찾지못하였습니다.",
  seckill_pro_2: "모금액은 최소 구입량보다 적어야 합니다.",
  seckill_pro_4: "시스템 사용중",
  seckill_pro_5: "프로젝트가 곧 시작될 예정입니다.",
  //支付
  seckill_pay_1: "시스템 사용중",
  seckill_pay_2: "시스템 사용중",
  seckill_pay_3: "프로젝트 정보 미조회",
  seckill_pay_4: "모금액은 최소 구입량보다 적어야 합니다.",
  seckill_pay_5: "구입 금액이 금번 회차의 잔여금액을 초과합니다.",
  seckill_pay_6: "없음",
  seckill_pay_7: "모금액은 최소 구입량보다 커야 합니다.",
  seckill_pay_8: "시스템 사용중",
  seckill_pay_9: "결제 비밀번호 오류",
  seckill_pay_10: "결제 실패 , 다시 시도해주시길 바랍니다.",
  seckill_pay_11: "결제 실패 , 다시 시도해주시길 바랍니다.",
  seckill_pay_12: "회원 정보 오류",
  seckill_pay_13: "결제 실패",
  seckill_pay_14: "결제 비밀번호 오류",
  seckill_pay_15: "시스템 사용중",
  seckill_pay_16: "매진",
  seckill_pay_17:
    "죄송합니다, 현재 구입 인원수가 많아, 이후 다시 시도해주시길 바랍니다.",
  seckill_pay_18: "매진",
  seckill_pay_19: "매진",
  seckill_pay_20: "로그인을 해주세요.",
  seckill_pay_21: "먼저 실명인증을 진행해주시길 바랍니다.",
  seckill_pay_22: "이 항목은 중국 KYC 사용자 청구만 제한합니다",
  seckill_pay_23: "이 항목은 비중국 대륙 KYC 사용자 청구에만 제한된다",
  seckill_pay_24:
    "거래 비밀번호 입력 횟수 초과, 잠시후 다시 시도해주시길 바랍니다.",
  seckill_hold_1:
    "현재 홀드한 [*] 수량이 부족하여 참여할 수 없습니다. 매수 후, 참여해주시길 바랍니다. ",
  // 问卷调查
  seckill_survey_submited: "이미 제출하였습니다",
  seckill_survey_error: "설문지 정보 오류",
  seckill_survey_info: "현재 프로젝트에서 관련 서류를 찾을 수 없습니다",
};

const addContent = {
  hdjshy:'이벤트가 종료되었습니다',
  qgsj: "구입 시간",
  qgsjNew: "시간",
  gz: "규칙",
  zdjg: "최저가",
  sq: "접기",
  qgms: "구입",
  rgxm: "프로젝트 참여",
  bled: "이번 회차 금액",
  dqjd: "현재 상황",
  yjs: "해제됨",
  yff: "이미 보상됨",
  qbcc: "확인",
  cg: "초과",
  jxmks: "프로젝트 시작",
  ycgrg: "모금 성공",
  cgrg: "구입 성공",
  xmed: "프로젝트 금액",
  cxmck: "해당 프로젝트 자금 조달액",
  ckmb: "모금 자금이 목표에 도달하였습니다.",
  ck: "목표 자금",
  ckxq: "자세히 보기",
  kqed: "가능",
  zhcc: "홀딩",
  jjks: "시작 예정",
  mmsz: "거래 비밀번호 설정 완료",
  qsz: "설정하기",
  qbye: "회원님 [*] 잔액은 [**]보다 커야합니다.",
  zjcz: "계정에 반드시 [*] [**] 이상인지 확인해주세요.",
  jgdb: "확실한 가격보장",
  jgyh: "VIP 혜택",
  bwbj: "피아트를 표준으로 가격 보호 기능 제공",
  bj: "[*]-일 가격 보장",
  sybj: "[*]% 보상, 가격 보호",
  zk: " VIP 할인혜택",
  r: "참여인",
  lsxm: "프로젝트 기록",
  bpf: "커뮤니티 파워, 풍부해진 혜택",
  syybz: "누구나 참여 가능한, 손쉬운 조건",
  hg: "VIP 회원시, 더 다양한 혜택",
  zgkx: "[*][**]까지 할인",
  vip_zgkx:
    "VIP 등급이 높을수록, 할인율이 높습니다. VIP 6 등급은 [*][**] 할인 혜택이 있습니다",
  vip_zgkxNew:
    "VIP 등급이 높을수록, 할인율이 높습니다. VIP 6 등급은 [*][**] 할인 혜택이 있습니다",
  blsysj: "마감",
  blqbqw: "매진",
  xyl: "다음",
  zskq: "시작",
  bljshs: "마감",
  zqyc: "매 라운드 별 1번씩 구입가능, 다음 라운드에서 구입해주세요. ",
  zxkf: "이 이벤트에 참여할 권한이 없습니다. 자세한 내용은 고객 서비스에 문의하십시오",
  zqycNew: "매 라운드별 한번만 참여 가능",
  wed: "구입 가능 금액은 0 입니다. 다음 세션을 기다렺쉐요.",
  wedNew: "참여 가능 모금액이 없으니, 다음 프로젝트를 기다려주세요.",
  zsqg: "최도 한도는 [*][**] 입니다. 구매 금액을 높여주세요.",
  srmm: "거래 비밀번호를 입력해주세요. ",
  smrz: "먼저 실명인증을 진행해주시길 바랍니다.",
  qszjymm: "먼저 거래 비밀번호를 설정하십시오",
  wenjuandiaocha: "먼저 설문조사를 완료하신 뒤, 해당 활동에 참여할 수 있습니다",
  scqgms: "프로모션",
  hxyh: "동전이 지역 사회에서 이길 수 있도록, 패턴 복지가 멈출 수 없다",
  zsqged: "최도 한도는 [*][**] 입니다",
  zsqgedNew: "최소 금액[*] [**]",
  wmtj: "현재 홀딩하고 있는 [**] 수량부족으로 참여하실 수 없습니다. 재구매후, 참여해주시길 바랍니다.",
  qjchqg: "구입 금액을 높여주세요.",
  qjchqgNew: "구입 후 참가해주시길바랍니다.",
  rgjg: "가격",
  qqg: "토큰 할인",
  wdqgjl: "나의 기록",
  ckxmxq: "프로젝트 정보 보기",
  t: "일",
  yr: "[*]월[**]일",
  yrz: "Round[*] 대기중",
  qgz: "Round[*] 구매중",
  djlyjs: "Round[*] 구매 종료",
  dj: "VIP 등급",
  xszk: "할인 가격을 누리다",
  jgzked: "참여 할인 금액",
  zked: "할인 한도",
  edw: "한도 밖 은 정상 가격 에 따라 지불한다",
  qbcczd: "계정에 반드시 1000 COINS 이상인지 확인해주세요.",
  qrrjcc: "7일 하루 창고 소지량",
  jlblks: "본선 에서 뺏다",
  jlbljs: "본선 종료",
  zgkqed: "최고 가량",
  zgkzf: "최고 지급 가능",
  cggmsl: "당신이 작성한 구매 수량은 당신의 구매 수량 제한을 초과했습니다",
  bzzfzxgm: "현재 창고 부족 지급 최소 구매량",
  bqzdqg: "이번 회차의 최저 구매액은 [*] [**] 이며",
  zlzcLower:
    "최저한도는 [*] 이며, 최고한도는 [**] 입니다. 5일 근무일(주말제외) 내로 계정으로 보상 될 것입니다.",
  zgqged: "최고 구매액은 [*] [**] 입니다",
  yzbz: "BiKing 팬을 위한 리미티드 할인",
  xszkj: "할인 비율",
  zlbxsq: "주요토큰 리미티드 할인",
  wks: "시작예정",
  jxz: "진행중",
  qgsl: "구입 수량",
  wcydxm: "참여한 프로젝트",
  bjq: "구입",
  hgq: "기간",
  qzk: "토큰 할인",
  qxzl: "CWT 구입시 보상",
  ds: "구입 한도",
  dhbl: "교환 비율 ",
  jicj: "기본가격",
  jiagzd: "최종 가격은 구입 시작 전 3시간내 결정됩니다.",
  zdyh: "최대 혜택",
};

const hyy = {
  bkt: "아니오",
  wqdkt: "확인",

  kt12: " 1.참여하기 전에 디지털 통화 계약 거래의 기본 지식 및 관련 위험과 파생상품 거래 참여와 관련된 업무 규칙을 철저히 이해해야 합니다.",
  kt13: "2. 위에서 언급한 리스크는 열거형일 뿐, 디지털 자산 파생상품 거래와 관련된 모든 리스크 요인의 상세한 리스트를 제시하지 못하고 있습니다. 투자자들은 디지털 자산 파생상품 거래에 투자하기 전에 다른 가능한 위험도 인지해야합니다. ",
  kt14: "3. 이번 계약 거래에 참여할 것인지의 여부에 대해 투자자들이 신중한 결정을 내리고 위험 감수성 등 자신의 실정에 따라 합리적으로 디지털 자산을 관리하는 것을 추천합니다. ",

  kt0: "친애하는 회원님께:",

  kt1: "귀하는 아직 계약 계좌를 개설하지 않았으며, 계약 거래 허가를 확인하지 않았습니다. 개설 여부를 결정하기 전에, 다음 약관을 주의 하여 읽어 주십시오.",

  kt2: "1. 계약 시장에서 거래할 때, 시장 가격 추세가 불리하고 포지션 마진이 불충분할 경우, BiKing 영구 계약은 시스템 계약에 따라 귀사의 입장을 강제적으로 확인하고 세부 사항을 공개합니다.",

  kt3: "2. BiKing 영구 계약의 업무 규칙을 주의 깊게 읽고 준수해야 하며, 계약의 메커니즘과 운영 원리를 이해해야 하며, 시장의 모든 위험을 이해해야 합니다.",

  kt4: "4. BiKing 영구 계약은 계약 거래 시스템에 액세스하고 있습니다. 계약 시장의 변동과 함께 사용자의 입장의 손익도 변화합니다. 큰 손실이 발생하면 trade system(trade system)에서 사라집니다. 사용자는 계약 시장에 따라 적시에 자신의 거래 행위를 해야 하며, 자신의 손익에 대한 책임이 있습니다. 따라서 BiKing는 어떠한 가정이나 확립된 보증 책임도 부담하지 않습니다",

  kt5: "5. 어떤 극단적인 시장 조건에서는 직책을 청산하는 것이 어렵거나 불가능할 수 있습니다. 예를 들어, 수익률이 계약 시장에서 유효 레버리지 PnL에서 1위를 차지하며, 상대편의 위치가 보험금이 손실을 메우기에는 불충분할 때 발생할 수 있습니다.",

  kt6: "6, 디지털 자산 파생상품 거래는 일정한 법역 내 정책감독의 위험에 직면할 수 있으므로, 거래 전에 거래의 규칙을 이해하고, 신중하게 판단해야 합니다. 해당 국가 및 지역 법률, 법규, 정책의 변화, 계약 거래소 거래 규칙의 개정, 긴급 조치의 출범 등으로 인해, 통화 흑자는 사전에 발표될 것이며, 귀하가 보유한 미완성 계약은 더 이상 보유하지 못할 수도 있지만, 보증금과 이익의 잔액은 그대로 유지됩니다.",

  kt7: "7. 부품 또는 전체 고장이 BiKing에 의해 통제되지 않는 이유, 예를 들어 지진, 홍수, 화재, 기타 불가항력 등의 이유로 인해 발생한 손실 또는 컴퓨터 또는 통신 시스템의 오작동 등이 스스로 수행됩니다.",

  kt8: "8. 투기 거래와 마찬가지로 '헤딩' 거래도 가격 변동으로 인한 리스크의 대상이 됩니다.",

  kta9: "9. 실명 인증이 없거나 Google 검증에 구속되지 않았거나 계정을 다른 사람에게 대여하면 계약 마진의 안전성이 저하될 수 있습니다.",
  kta10:
    "3. 어떤 극단적인 시장 조건에서는 직책을 청산하는 것이 어렵거나 불가능할 수 있습니다. 예를 들어, 수익률이 계약 시장에서 유효 레버리지 PnL에서 1위를 차지하며, 상대편의 위치가 보험금이 손실을 메우기에는 불충분할 때 발생할 수 있습니다.",

  kt9: "해당 위험경고 약관을 읽고 동의하였습니다.",
  kt10: "계약 열기 및 허가",
  zjhz: "이체",
  ljhz: "이체하기",
  qx: "취소",
  khz: "이체할 수 있습니다.",
  qxz: "선택",
  bz: "토큰 종료",
  c: "부터",
  zz: "로 이체",
  sl: "수량",
  qb: "전부",
  ktcg: "성공",
  ktsb: "실패",
  hzcg: "성공",
  hzsb: "실패",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "물러나다",
  warning1: "토큰을 선택해주세요",
  warning2: "이체금액을 입력해주세요",
  warning3: "입금금액을 입력해주세요",
  warning4: "이체 가능한 금액보다 적은 금액을 입력해주세요.",
  warning5: "최대 4 비트 소수 유지",
  gb: "닫기",
  openSuccess: "이미 계약을 오픈하였습니다.",
  openSuccessTip: "먼저 계약 계정을 개설해야합니다.",
  not_get_nm:
    "죄송하지만, 클레이칩 활동은 이미 발송되었는데, 이번 회전은 진흙 코드를 얻지 못했다",
};

const trading = {
  reload: "새로 고침",
  socketError: "네트워크 오류입니다.",
  noData: "기록없음",
  entrustorder: "호가창",
  prices: "가격",
  quantity: "수량",
  grandtotal: "누적",
  transamount: "총",
  time: "시간",
  available: "사용가능",
  limitorder: "지정가 주문",
  plancommission: "트리거 주문",
  currentcommission: "현재 주문",
  historycommission: "주문 기록",
  completecommission: "주문 완료",
  hidetrading: "다른 페어 주문 숨기기",
  morecurrentcommission: "더보기",
  morehistorycommission: "기록보기",
  moredocommission: "자세히보기",
  realtimetrans: "실시간 체결",
  myassets: "나의 자산",
  detail: "더보기",
  buyin: "매수",
  sellout: "매도",
  login: "로그인",
  transfer: "이체",
  recharge: "입금",
  withdrawal: "코인구매",
  quickpurchase: "OTC 빠른 구매",
  default: "기본",
  ordertime: "주문 시간",
  tradingpair: "거래 페어",
  direction: "방향",
  types: "유형",
  commissionprice: "주문가격",
  commissionnumber: "주문 수량",
  dealprice: "체결 평균가격",
  dealnumber: "체결 수량",
  triggerprice: "트리거 가격",
  cancelall: "모두 철회",
  averageprice: "평균가",
  totalsum: "합계",
  fixedprice: "지정가",
  marketprice: "시장가",
  codeExpired: "QR 코드 기한이 초과되었습니다.",
  clickRefresh: "클릭 후 새로고침",
  QRsuccessfully: "성공",
  loginInApp: "APP 내에서 로그인을 확인해주세요.",
  backtoQR: "QR 코드 로그인으로 돌아가기",
  loginSuccess: "로그인 성공, BiKing 에 오신걸 환영합니다.",
  loadingText: "로딩중...",
  searchPlaceholder: "검색",
  all: "모두",
  currency: "코인",
  price: "최신가격",
  market: "상승",
  increase: "변경",
  highestPrice: "최고",
  minimumPrice: "최저",
  turnover: "시간 거래량",
  jydlb: "페어 정렬",
  bzjs: "화폐 소개",
  currencyTransaction: "거래",
  leveragedTransaction: "레버리지",
  warning:
    "위험경고: Bitcoin Cash에는 큰 불확실성이 있습니다. 해당 선물 토큰을 거래하거나 투자하는 것은 매우 큰 위험성을 내포하고있습니다. 마이너의 지원이 부족한 체인은 생존 할 수 없으며, 보유한 토큰의 가치가 0이됩니다. BiKing는 분기된 선물 토큰의 가치에 대해 어떠한 책임과 보장도 하지 않습니다!",
  zb: "지표",
  UpAnddown: "변동",
  amplitude: "변동폭",
  0: "분시",
  1: "1분",
  5: "5분",
  15: "15분",
  30: "30분",
  60: "1시간",
  240: "4시간",
  3600: "1일",
  10800: "1주",
  dates: "주기：",
  password: "거래 비밀번호",
  errorPassword: "올바른 비밀번호를 입력하십시오",
  worningPassword: "거래 비밀번호를 입력해주세요.",
  cancel: "취소",
  sure: "확인하다",
  canBuy: "매수가능",
  canCell: "매도가능",
  withdraw: "출금",
  otc: "OTC，법정화폐 빠른 입금",
  enterPrice: "가격을 입력해주세요.",
  sellingPrice: "매도 가격",
  purchasePrice: "매수가격",
  salesVolume: "매도량",
  buyingVolume: "매수수량",
  volume: "총",
  serviceCharge: "Fee",
  vip: "VIP획득, 수수료 면제",
  or: "/",
  register: "회원가입",
  totalPrice: "거래수량은 보다 클 수 없습니다",
  amountTip: "올바른 수량을 입력하십시오",
  amountTipError: "수량은 보다 클 수 없습니다",
 
  limitTrading: "지정가",
  priceReminder: "가격 알림",
  SMSReminder: "메시지 알림",
  loginAccount: "로그인 계정",
  phone: "휴대폰",
  phoneNum: "휴대폰 번호를 입력해주세요.",
  phoneTips: "올바른 휴대폰 반호를 입력하십시오",
  email: "이메일",
  emailNum: "이메일 주소를 입력해주세요.",
  emailTips: "이메일을 입력하십시오",
  aears: "지역코드를 선택하세요",
  passwordError: "올바른 비밀번호를 입력하십시오",
  passwordTips: "거래 비밀번호를 입력해주세요",
  forgetPassword: "비밀번호 분실",
  noAccount: "아직 없어 요.",
  goRegister: "즉각 등록",
  appsys: "APP 스캔 후 로그인",
  xzapp: "최신버전 APP 다운로드 하기",
  mmdl: "비밀번호를 입력하세요",
  smdl: "스캔 후 로그인",
  google: "구글인증기",
  nybd: "당신 은 이미 귀속 하 였 습 니 다",
  zqyzm: "올바른 인증코드를 입력하십시오",
  fsyzm: "코드 전송",
  flv: "요율",
  jz: "순자산",
  jzdesc1:
    "롱 순자산 = 마지막 조정 시점의 순자산 * [1 + 3 * (현장의 마지막 조정 시점의 가격)/현 마지막 조정 시점의 가격 * 100%];",
  jzdesc2:
    "숏 순자산 = 마지막 조정 시점의 순자산 * [1 - 3 * (현장의 마지막 조정 시점의 가격)/현 마지막 조정 시점의 가격 * 100%];",
  sbd: "3배 롱",
  sbs: "3배 숏",
  flvjs:
    'ETF 펀드비는 플랫폼이 매일 레버리지에 대해 해당 비율의 관리비를 부과하여, 펀드 조합에 따른 비용을 지불합니다. 관리비는 순가치 변화종, 즉 "해당 레퍼런스 ETF의 가치를 차감"하는 방식으로 구현되고, 싱가포르 시간 0시에만 부과되며, 이 시점에서 제품을 보유하지 않으면 비용이 발생하지 않습니다.',
  mzsm: "면책성명",
  ido: "읽고 동의하였습니다",
  exemption1: "고객님 안녕하십니까！",
  exemption2:
    "BiKing 플랫폼( BiKing.ai)에 로그인 및 ETF 관련된 상품 (이하 'ETF상품') 을 이용해주셔서 감사드립니다. ETF상품 설명과 해당 위험 공지를 반드시 숙지해주시길 바랍니다. 만약 해당 창 종료 후, ETF 상품 사용하실 경우, 해당 위험 사항에 대해 이미 숙지 및 동의하신걸로 간주됩니다. 또한, 손실의 경우 역시, 본인의 책임으로 간주됨에 동의합니다.클릭 후, ETF 상품 설명을 읽어주시길 바랍니다. ",
  exemption3: "<레버리지 ETF 상품 FAQ>",
  exemption4: "위험 경고:",
  exemption5:
    "1. 매수/매도 가격이 해당 단위의 순자산에서 크게 벗어나서는 안 됩니다. 그렇지 않으면 그에 상응하는 손실을 보게 됩니다.",
  exemption6:
    "2. 방향이 틀리경우, 극조건에서 가격이 0에 근접할 위험이 있습니다.",
  exemption7:
    "BiKing는 위의 위험으로 인한 손실의 책임은 사용자 본인이 부담할 것이며, BiKing는 이에 대한 어떠한 책임도 지지 않을 것임을 엄숙히 상기시켜 드립니다. 이 사항은 다른 계약, 진술, 규칙 등과 함께 귀하와 BiKing 간의 BiKing의 서비스와 제품에 대해 도달한 모든 계약을 구성합니다.\n",
  bzjs1:
    '1、"3L"은 기본 거래 페어의 가격이 1% 상승하여, 제품의 순 가치가 3% 증가함을 의미합니다.',
  bzjs2:
    '2、"3S"는 기본 거래 페어의 가격이 1% 하락하여 제품의 순 가치가 3% 상승하는 것을 의미합니다.',
  bzjs3:
    "3、순자산은 보통 매일 0시에 조정되며, 극한 시장에서는 인트라데이에서 조정됩니다.",
  bzjs4: "4、매번 레버리지가 매일 해당 관리 비용을 청구합니다.",
  bzjs5:
    "5、거래 전 순자산 확인에 유의하시기 바랍니다. 극단적인 시장 상황에서 가격은 0에 가까워질 것이고 순자산에서 크게 벗어날 것입니다. 투자자들은 위험을 통제하는 데 주의를 기울여야 합니다.",
  gdjk: "자세한 사항은 공고에서 확인해주세요",
  firstTrading: "거래 전, 거래 비밀번호를 설정해주세요.",
  status: "상태",
  status1: "매치됨",
  status2: "미완료",
  status3: "취소됨",
  status4: "부분 완료",
  status5: "완료",
  status6: "무효",
  allCancel:
    "이 목록에 없는 Exchange 및 ETF 주문을 포함하여 모든 주문을 일괄 취소합니다.",
  canceld: "취소됨",
  cancelsuccess: "모든 주문이 취소되었습니다. [*]개의 주문이 취소되었습니다.",
  VIP1: "나의 VIP레벨",
  VIP2: "거래 수수료 비용은 낮지만 거래 경험은 향상되었습니다.",
  VIP3: "Taker(테이커)：",
  VIP4: "Maker(메이커)：",
  buyAmount: "수량은 보다 클 수 없습니다",
  sellAmount: "수량은 보다 클 수 없습니다",
  buyAmountMin: "당신 의 구입 가능 잔액 이 부족 합 니 다.",
  sellAmountMin: "당신 의 판매 가능 잔액 이 부족 합 니 다.",
};

const transferDialog = {
   amountLowTipError: "Quantity cannot be lower than",
  划转: "이체",
  资金互转: "이체",
  币币账户: "교환 계정",
  买币账户: "매수 수량",
  已冻结: "동결됨",
  合约账户: "계약 계정",
  未开通: "미개통",
  杠杆账户: "레버리비 계정",
  币贷宝账户: "비트론 계정",
  从: "부터",
  转至: "이체",
  币种: "코인",
  数量: "수량",
  全部: "전부",
  用户未归还借贷的情况下:
    "만약 미 상환시, 위험관리등급이 200% 높아져, 출금 가능 할 수 있습니다",
  可划转: "이체 가능",
  一阶: "1. 레벨 1",
  累计净划入: "누적 이체량",
  可获得: "웰컴보너스 획득",
  泥码: "를 얻을 수 있습니다",
  二阶: "2. 레벨 2",
  您尚未完成实名认证: "실명 인증은 완료되지 않았습니다.",
  余额: "잔고",
  立即划转: "바로 이체",
  资产划转: "이체",
  用于维持现有仓位的保证金: "유지보수를 위한 마진",
  归还数量: "상환수량",
  您的币贷宝账户尚未开通:
    "회원님의 비트론 계정 개설되지않았습니다. 먼저 개설해주시길 바랍니다.",
  请输入正确的数量: "정확한 수량을 입력해주세요.",
  划转金额不能为: "이체 금액 은 0 이면 안 됩 니 다.",
  账户可用余额不足: "계 정 이용 잔액 이 부족 합 니 다.",
  划转失败: "실패",
  划转成功: "성공",
  本次划转未能获得泥码:
    "죄송하지만, 클레이칩 활동은 이미 발송되었는데, 이번 회전은 진흙 코드를 얻지 못했다",
  您只需再向合约账户划转:
    "당신은 단지 계약 계정에 [*] USDT를 이체하기만 하면 [**] USDT 흙코드를 얻을 수 있습니다",
  您向合约账户: "계약 계정 [*]USDT <br/>이상에 대한 누적 이체, 획득",
  请输入划转数量: "이체 수량을 입력해주세요",
};

export {
  state,
  subheader,
  purchase,
  purchaseCondition,
  historyProject,
  alipay,
  projectDetails,
  purchaseOver,
  myPurchase,
  mHeader,
  res,
  addContent,
  hyy,
  trading,
  common,
  transferDialog,
};



// WEBPACK FOOTER //
// ./src/i18n/lang/kr.js